"use strict";

var SpreadsheetImportMapper = function(targetAttributes, defaultMappings, transform, synonyms) {
	this.targetAttributes = _(targetAttributes).clone();
	this.defaultMappings = _(defaultMappings).clone();
	this.transform = transform;
	this.synonyms = _(synonyms).clone();

	// add lowercase and uppercase of targetattributes to synonyms
	if (!this.synonyms) {
        this.synonyms = {};
        this.columnNames = {};
    } else {
        this.columnNames = _(this.synonyms).invert();
        _(Object.keys(this.synonyms)).each(function (key) {
            this.synonyms[key.toLowerCase()] = this.synonyms[key];
        }, this);
    }
	_(Object.keys(this.targetAttributes)).each(function (key) {
		this.synonyms[key.toLowerCase()] = key;
	}, this);
};

SpreadsheetImportMapper.prototype.reset = function() {
	delete this.rows;
	delete this.columns;
	delete this.mappings;
	delete this.columnMappings;
};

/** Parses TSV content */
SpreadsheetImportMapper.prototype.parse = function(content) {
	this.rows = [];
	// Replace new-lines in quotes
	var temp = content.split('"');
	for (var i = 0; i < temp.length; i++) {
		if (i % 2 == 1)
			temp[i] = temp[i].replace(/\n/g,"\\n");
	}
	content = temp.join('');

	var lines = content.split('\n');
	this.mappings = [];
	if (lines.length > 0) {
		this.columns = lines[0].split('\t');
		for (var i = 1; i < lines.length; i++) {
			var line = lines[i];
			line = line.replace(/\\n/g,"\n");
			if (!line || line.trim().length == 0)
				continue;
			var row = line.split('\t');
			this.rows.push(row);
		}
		for (var i = 0; i < this.columns.length; i++) {
			var column = this.columns[i];
			if (column in this.targetAttributes)
				this.mappings.push({ key: column });
			else if (column.toLowerCase() in this.defaultMappings)
				this.mappings.push(this.defaultMappings[column.toLowerCase()]);
			else if (this.synonyms && this.synonyms[column.toLowerCase()] in this.targetAttributes)
				this.mappings.push({ key: this.synonyms[column.toLowerCase()] });
			else if (this.synonyms && this.synonyms[column.toLowerCase()] in this.defaultMappings)
				this.mappings.push(this.defaultMappings[this.synonyms[column.toLowerCase()]]);
			else {
				console.log('mapping not found for column ' + this.columns[i]);
				this.mappings.push(null);
			}
		}
		// Re-order keys
		for (var i = 0; i < this.mappings.length; i++) {
			if (this.mappings[i])
				this.mappings[i].column = i;
		}
		this.mappings = _(this.mappings).sortBy(function (mapping) { return mapping ? mapping.position : undefined; });
		this.columnMappings = [];
		for (var i = 0; i < this.mappings.length; i++) {
			var mapping = this.mappings[i];
			if (mapping)
				this.columnMappings[mapping.column] = mapping;
		}
	}
	this.content = content;
};

/** Maps parsed content into objects */
SpreadsheetImportMapper.prototype.map = function() {
	var objects = [];
	for (var r = 0; r < this.rows.length; r++) {
		var obj = {};
		for (var i = 0; i < this.rows[r].length; i++) {
			var mapping = this.mappings[i];
			if (!mapping) {
                var key = this.columns[i];
                var value = this.rows[r][i];
                if (value) obj[key] = value;
                continue;
            }
			var key = mapping.key;
			var value = this.rows[r][mapping.column];
			var target = this.targetAttributes[key];
			if (!value)
				continue;
			
			try {
				value = value.trim();
				if (target && target.type == 'boolean') {
					if (value.length > 0) {
						if (value == '1' || value.toLowerCase() == 'x' || value.toLowerCase()[0] == 'y' || value.toLowerCase()[0] == 'j' || value.toLowerCase() == 'true')
							obj[key] = true;
						else
							obj[key] = false;
					}
				} else if (target && target.type == 'date') {
					var date = new Date(value);
					if (isNaN(date.getTime()))
						date = Formatting.parseDate(value);
					if (isNaN(date.getTime()))
						date = Formatting.parseTime(value);
					if (!isNaN(date.getTime()))
						obj[key] = date.getTime();
				} else if (target && target.type == 'int')
					obj[key] = parseInt(value);
				else if (target && target.type == 'float')
					obj[key] = parseFloat(value.replace(',','.'));
                else if (key in obj)
					obj[key] += (target.prepend ? target.prepend : mapping.prepend ? mapping.prepend : "\n") + value;
				else
					obj[key] = value;
			} catch (err) {
				console.error('Failed to map ' + key + ' at row ' + r + ' column ' + i, err);
			}
		}
		if (this.transform)
			obj = this.transform(obj);
		if (obj)
			objects.push(obj);
	}
	return objects;
};

